import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { IFeriadoDTO, IFeriadoListProps } from "../../../types/feriado";
import { Feriado } from "../../../services/Feriado";
import { IPagination } from "../../../types/pagination";
import { useContextSite } from "../../../context/Context";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useSessionStorage } from "../../../hooks/useSessionStorage";

export const useHolidays = () => {
  const [open, setOpen] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: "640px" });
  const [feriados, setFeriados] = useState<IFeriadoDTO[]>([] as IFeriadoDTO[]);
  const [pagination, setPagination] = useState<IPagination>({} as IPagination);
  const [numberPage, setNumberPage] = useState(0);
  const { setIsLoad } = useContextSite();
  const [filters, setFilters] = useState<IFeriadoListProps>(
    {} as IFeriadoListProps
  );
  const navigate = useNavigate();
  const [usuario] = useSessionStorage("@usuarioMapa");
  const isAdmin = usuario?.roles?.includes("ROLE_ADMIN");
  const canEditHolidays =
    isAdmin || usuario?.recursos?.includes("CONFIGURACAO_FERIADO_EDITAR“");

  function getFeriados(data?: IFeriadoListProps) {
    setIsLoad(true);
    Feriado.list({ page: numberPage, size: 5, ativo: true, ...data })
      .then(({ data }) => {
        setFeriados(data.content);
        setPagination({
          actualPage: data.number,
          totalPage: data.totalPages,
          totalRegister: data.numberOfElements,
        });
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => setIsLoad(false));
  }

  useEffect(() => {
    getFeriados(filters);
  }, [numberPage]);

  function handleFilter(data: IFeriadoListProps) {
    setFilters(data);
    const hasItem = Object.values(data).some((i) => i);

    if (hasItem) {
      getFeriados({ page: 0, ...data });
    }
  }

  function handleClean() {
    getFeriados({ page: 0 });
    setNumberPage(0);
    setFilters({} as IFeriadoListProps);
  }

  function handleDelete(uuidFeriado: string) {
    setIsLoad(true);
    Feriado.delete({ uuidFeriado })
      .then(() => {
        toast.success("Feriado deletado com sucesso!");
        getFeriados();
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => setIsLoad(false));
  }

  return {
    handleClean,
    open,
    setOpen,
    isMobile,
    pagination,
    setNumberPage,
    feriados,
    handleFilter,
    navigate,
    handleDelete,
    canEditHolidays,
  };
};
